import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link as RouterLink } from 'react-router-dom';

const Link = React.forwardRef<
  HTMLAnchorElement,
  React.ComponentProps<typeof RouterLink>
>((props, ref) => {
  return <RouterLink {...props} ref={ref} />;
});

export default Link;
